/* eslint-disable @typescript-eslint/consistent-type-assertions */

import { useRandomDirectAdCreative } from '../../composables/data-fetching/useRandomDirectAdCreative/useRandomDirectAdCreative'
import { useAnalytics } from '../../composables/analytics/useAnalytics'
import type { Creative, DirectAdsFlight } from '../../server/models/direct-ads'
import type {
  AdBlock,
  LayoutSkeleton,
} from '../../composables/data-fetching/auto-layout/index.types'

interface DirectAdsMixpanelProps {
  ntp_ad_provider: 'direct'
  ntp_creative_id: string
  ntp_ad_brand: string
  ntp_ad_clickurl: string
  ntp_ad_advertiser: string
  ntp_ad_campaign_name: string
  ntp_ad_open_with: 'both' | 'default-browser' | 'current-browser'
  ntp_placement_name?: string
}

export function getDirectAdsMixpanelProps(
  creative: Creative
): DirectAdsMixpanelProps {
  return {
    ntp_ad_provider: 'direct',
    ntp_creative_id: creative.creativeName,
    ntp_ad_brand: creative.brand,
    ntp_ad_clickurl: creative.clickUrl,
    ntp_ad_advertiser: creative.advertiser,
    ntp_ad_campaign_name: creative.campaign,
    ntp_ad_open_with:
      creative.shouldOpenInDefaultBrowser && creative.shouldOpenInCurrentBrowser
        ? 'both'
        : creative.shouldOpenInDefaultBrowser
          ? 'default-browser'
          : 'current-browser',
    ntp_placement_name: creative.placement,
  }
}

const { track } = useAnalytics()

export function handleDirectAdClick(creative: Creative) {
  const { clickUrl, shouldOpenInDefaultBrowser, shouldOpenInCurrentBrowser } =
    creative

  track('NtpAd_Clicked', getDirectAdsMixpanelProps(creative))

  if (clickUrl && shouldOpenInDefaultBrowser) {
    openInDefaultBrowser(clickUrl)
  }
  if (clickUrl && shouldOpenInCurrentBrowser) {
    window.open(clickUrl, '_blank')
  }
}

export function handleDirectAdRender(creative: Creative) {
  track('NtpAd_Rendered', getDirectAdsMixpanelProps(creative))
}

function replaceAdBlockWithDirectAd(
  directAdCampaign: DirectAdsFlight,
  ad: AdBlock
) {
  if (ad.props && ad.props.creative) return
  const classList = ad.classes?.split(' ')
  const filteredClassList = classList?.filter(
    (c) => c !== directAdCampaign.position.placement && c !== 'no-padding'
  )
  ad.classes = filteredClassList?.join(' ')
  ad.props = {
    ...(ad.props as object),
    adType: 'direct',
    creative: {
      ...useRandomDirectAdCreative(directAdCampaign.creatives),
      shouldOpenInDefaultBrowser: directAdCampaign.shouldOpenInDefaultBrowser,
      shouldOpenInCurrentBrowser: directAdCampaign.shouldOpenInDefaultBrowser
        ? directAdCampaign.shouldOpenInCurrentBrowser
        : true,
    },
  }
}

function findMatchingAdBlock(directAdCampaign: DirectAdsFlight, ad: AdBlock) {
  if (
    ad.x !== directAdCampaign.position.x ||
    ad.y !== directAdCampaign.position.y
  )
    return
  const randomNumber = Math.floor(Math.random() * 100)
  if (randomNumber > directAdCampaign.splitPercentage) return
  replaceAdBlockWithDirectAd(directAdCampaign, ad)
}

export function injectDirectAds(
  directAdCampaigns: DirectAdsFlight[],
  layoutDefinition: LayoutSkeleton
) {
  directAdCampaigns.forEach((directAdCampaign) => {
    layoutDefinition.section[directAdCampaign.position.section].ads?.forEach(
      (ad: AdBlock) => {
        findMatchingAdBlock(directAdCampaign, ad)
      }
    )
  })
}
